/* tslint:disable */
/* eslint-disable */
/**
 * Altair 2 API
 * API for users, groups, links, etc..
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLink200Response
 */
export interface GetLink200Response {
    /**
     * Link ID
     * @type {string}
     * @memberof GetLink200Response
     */
    linkId: string;
    /**
     * Type of the link
     * @type {string}
     * @memberof GetLink200Response
     */
    type: GetLink200ResponseTypeEnum;
    /**
     * Group name (if applicable)
     * @type {string}
     * @memberof GetLink200Response
     */
    groupName?: string;
    /**
     * Product id, used to open the product page directly in case the user owns the product
     * @type {string}
     * @memberof GetLink200Response
     */
    productId?: string;
    /**
     * Product title (if applicable)
     * @type {string}
     * @memberof GetLink200Response
     */
    productTitle?: string;
    /**
     * Product subtitle (if applicable)
     * @type {string}
     * @memberof GetLink200Response
     */
    productSubTitle?: string;
    /**
     * Product cover image (if applicable)
     * @type {string}
     * @memberof GetLink200Response
     */
    productCoverImage?: string;
    /**
     * User already owns the product
     * @type {boolean}
     * @memberof GetLink200Response
     */
    ownsProduct: boolean;
    /**
     * User is a member of the group, in case this is a group invite link
     * @type {boolean}
     * @memberof GetLink200Response
     */
    groupMember?: boolean;
    /**
     * Checkout url, in case the product must be purchased beforehand
     * @type {string}
     * @memberof GetLink200Response
     */
    checkoutUrl?: string;
}


/**
 * @export
 */
export const GetLink200ResponseTypeEnum = {
    Product: 'product',
    Group: 'group'
} as const;
export type GetLink200ResponseTypeEnum = typeof GetLink200ResponseTypeEnum[keyof typeof GetLink200ResponseTypeEnum];


/**
 * Check if a given object implements the GetLink200Response interface.
 */
export function instanceOfGetLink200Response(value: object): value is GetLink200Response {
    if (!('linkId' in value) || value['linkId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('ownsProduct' in value) || value['ownsProduct'] === undefined) return false;
    return true;
}

export function GetLink200ResponseFromJSON(json: any): GetLink200Response {
    return GetLink200ResponseFromJSONTyped(json, false);
}

export function GetLink200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLink200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'linkId': json['linkId'],
        'type': json['type'],
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'productId': json['productId'] == null ? undefined : json['productId'],
        'productTitle': json['productTitle'] == null ? undefined : json['productTitle'],
        'productSubTitle': json['productSubTitle'] == null ? undefined : json['productSubTitle'],
        'productCoverImage': json['productCoverImage'] == null ? undefined : json['productCoverImage'],
        'ownsProduct': json['ownsProduct'],
        'groupMember': json['groupMember'] == null ? undefined : json['groupMember'],
        'checkoutUrl': json['checkoutUrl'] == null ? undefined : json['checkoutUrl'],
    };
}

export function GetLink200ResponseToJSON(json: any): GetLink200Response {
    return GetLink200ResponseToJSONTyped(json, false);
}

export function GetLink200ResponseToJSONTyped(value?: GetLink200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'linkId': value['linkId'],
        'type': value['type'],
        'groupName': value['groupName'],
        'productId': value['productId'],
        'productTitle': value['productTitle'],
        'productSubTitle': value['productSubTitle'],
        'productCoverImage': value['productCoverImage'],
        'ownsProduct': value['ownsProduct'],
        'groupMember': value['groupMember'],
        'checkoutUrl': value['checkoutUrl'],
    };
}

